import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { authConfig } from './core/auth/auth.config';
import { GateThemePreset } from 'src/gate-theme-preset';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor()])),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAuth(authConfig, withAppInitializerAuthCheck()),
    provideAnimations(),
     providePrimeNG({
      overlayAppendTo: 'body',
      theme: {
        preset: GateThemePreset,
        options: {
          darkModeSelector: '.dark',
          CSSLayer: 'styles.css',
        },
      },
      pt: {
          select: {
            header: {
              class: ['!p-1'],
            }
          }
       }
    }),
  ],
};
